import {
  EDIT_PROFILE_ERROR,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE,
  RESET_PROFILE_FLAG,
  SET_PROFILE,
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  UPDATE_PROFILE_AVATAR,
  UPDATE_PROFILE_AVATAR_SUCCESS,
  UPDATE_PROFILE_AVATAR_ERROR,
} from "./actionTypes";

const initialState = {
  error: "",
  success: "",
  user: {},
  loadingProfile: false,
  chPassError: "",
  chPassSuccess: "",
  chPassLoading: false,
  updatingAvatar: false,
  updateAvatarError: null,
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFILE:
      state = { ...state, loadingProfile: true, error: "", success: "" };
      break;
    case GET_PROFILE_SUCCESS:
      state = {
        ...state,
        user: { ...state.user, ...action.payload },
        loadingProfile: false,
      };
      break;
    case GET_PROFILE_ERROR:
      {
        state = {
          ...state,
          error: action.payload,
          loadingProfile: false,
        };
      }
      break;
    case EDIT_PROFILE:
      state = { ...state, loading: true };
      break;
    case EDIT_PROFILE_SUCCESS:
      state = {
        ...state,
        user: action.payload,
        loading: false,
      };
      break;
    case EDIT_PROFILE_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      };
      break;
    case RESET_PROFILE_FLAG:
      state = {
        ...state,
        error: null,
        chPassError: null,
        chPassSuccess: null,
        updateAvatarError: false,
      };
      break;
    case SET_PROFILE:
      state = {
        ...state,
        user: action.payload,
      };
      break;
    case CHANGE_PASSWORD:
      state = {
        ...state,
        chPassLoading: true,
      };
      break;
    case CHANGE_PASSWORD_SUCCESS:
      state = {
        ...state,
        chPassSuccess: action.payload,
        chPassLoading: false,
      };
      break;

    case CHANGE_PASSWORD_ERROR:
      state = {
        ...state,
        chPassError: action.payload,
        chPassLoading: false,
      };
      break;
    case UPDATE_PROFILE_AVATAR:
      state = {
        ...state,
        updatingAvatar: true,
      };
      break;
    case UPDATE_PROFILE_AVATAR_SUCCESS:
      state = {
        ...state,
        updatingAvatar: false,
        user: { ...state.user, avatar: action.payload?.url },
      };
      break;
    case UPDATE_PROFILE_AVATAR_ERROR:
      state = {
        ...state,
        updatingAvatar: false,
        updateAvatarError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default profile;
